import { createQuestionnaire, createQuestionnaireInitialValues } from "./CombineJsons";

//Initial values
import iDecon from "./Json/InitialValueSets/Decon.json";
import iEQ5D from "./Json/InitialValueSets/EQ5D.json";
import iGAD7 from "./Json/InitialValueSets/GAD7.json";
import iMedialBranchBlock from "./Json/InitialValueSets/MedialBranchBlock.json";
import iMSK from "./Json/InitialValueSets/MSK.json";
import iMskBaselineHealth from "./Json/InitialValueSets/MskBaselineHealth.json";
import iMskBaselinePersonal from "./Json/InitialValueSets/MskBaselinePersonal.json";
import iMskDischargeHealth from "./Json/InitialValueSets/MskDischargeHealth.json";
import iMskDischargePersonal from "./Json/InitialValueSets/MskDischargePersonal.json";
import iMskMonthsDischargePrems from "./Json/InitialValueSets/MskMonthsDischargePrems.json";
import iMskPrems from "./Json/InitialValueSets/MskPrems.json";
import iPAM from "./Json/InitialValueSets/PAM.json";
import iPHQ8 from "./Json/InitialValueSets/PHQ8.json";
import iPHQ9 from "./Json/InitialValueSets/PHQ9.json";
import iGeneralPromsInitial from "./Json/InitialValueSets/GeneralPromsInitial.json";
import iManchesterPromsInitial from "./Json/InitialValueSets/ManchesterPromsInitial.json";
import iPSEQ8And9 from "./Json/InitialValueSets/PSEQ8And9.json";
import iPSFS from "./Json/InitialValueSets/PSFS.json";
import iPSFSDischarge from "./Json/InitialValueSets/PSFSDischarge.json";
import iSleepProgramme from "./Json/InitialValueSets/SleepProgramme.json";
import iStartMsk from "./Json/InitialValueSets/StartMsk.json";
import iStartBack from "./Json/InitialValueSets/StartBack.json";
import iTestingElements from "./Json/InitialValueSets/TestingElements.json";
import iTestingElementsFailure from "./Json/InitialValueSets/TestingElementsFailure.json";
import iPainPersonal from "./Json/InitialValueSets/PainPersonal.json";
import iPainBaselineHealth from "./Json/InitialValueSets/PainBaselineHealth.json";
import iBpi from "./Json/InitialValueSets/Bpi.json";
import iMpfi from "./Json/InitialValueSets/MPFI.json";
import iCore10 from "./Json/InitialValueSets/CORE10.json";
import iPainDischargePersonal from "./Json/InitialValueSets/PainDischargePersonal.json";
import iPainDischargeHealth from "./Json/InitialValueSets/PainDischargeHealth.json";
import iFft from "./Json/InitialValueSets/Fft.json";
import iPainMedication from "./Json/InitialValueSets/PainMedication.json";
import iPainSatisfaction from "./Json/InitialValueSets/PainSatisfaction.json";
import iPainPersonalManchester from "./Json/InitialValueSets/PainPersonalManchester.json";

//Question JSONs
import qDecon from "./Json/QuestionSets/Decon.json";
import qEQ5D from "./Json/QuestionSets/EQ5D.json";
import qGAD7 from "./Json/QuestionSets/GAD7.json";
import qMedialBranchBlock from "./Json/QuestionSets/MedialBranchBlock.json";
import qMSK from "./Json/QuestionSets/MSK.json";
import qMskBaselineHealth from "./Json/QuestionSets/MskBaselineHealth.json";
import qMskBaselinePersonal from "./Json/QuestionSets/MskBaselinePersonal.json";
import qMskDischargeHealth from "./Json/QuestionSets/MskDischargeHealth.json";
import qMskDischargePersonal from "./Json/QuestionSets/MskDischargePersonal.json";
import qMskMonthsDischargePrems from "./Json/QuestionSets/MskMonthsDischargePrems.json";
import qMskPrems from "./Json/QuestionSets/MskPrems.json";
import qPAM from "./Json/QuestionSets/PAM.json";
import qPHQ8 from "./Json/QuestionSets/PHQ8.json";
import qPHQ9 from "./Json/QuestionSets/PHQ9.json";
import qGeneralPromsInitial from "./Json/QuestionSets/GeneralPromsInitial.json";
import qManchesterPromsInitial from "./Json/QuestionSets/ManchesterPromsInitial.json";
import qPSEQ8And9 from "./Json/QuestionSets/PSEQ8And9.json";
import qPSFS from "./Json/QuestionSets/PSFS.json";
import qPSFSDischarge from "./Json/QuestionSets/PSFSDischarge.json";
import qSleepProgramme from "./Json/QuestionSets/SleepProgramme.json";
import qStartMsk from "./Json/QuestionSets/StartMsk.json";
import qStartBack from "./Json/QuestionSets/StartBack.json";
import qTestingElements from "./Json/QuestionSets/TestingElements.json";
import qTestingElementsFailure from "./Json/QuestionSets/TestingElementsFailure.json";
import qPainPersonal from "./Json/QuestionSets/PainPersonal.json";
import qPainBaselineHealth from "./Json/QuestionSets/PainBaselineHealth.json";
import qBpi from "./Json/QuestionSets/Bpi.json";
import qMpfi from "./Json/QuestionSets/MPFI.json";
import qCore10 from "./Json/QuestionSets/CORE10.json";
import qPainDischargePersonal from "./Json/QuestionSets/PainDischargePersonal.json";
import qPainDischargeHealth from "./Json/QuestionSets/PainDischargeHealth.json";
import qFft from "./Json/QuestionSets/Fft.json";
import qPainMedication from "./Json/QuestionSets/PainMedication.json";
import qPainSatisfaction from "./Json/QuestionSets/PainSatisfaction.json";
import qPainPersonalManchester from "./Json/QuestionSets/PainPersonalManchester.json";

//Question set wrapper JSONS
import wDecon from "./Json/QuestionSetWrappers/Decon.json";
import wEmpty from "./Json/QuestionSetWrappers/Empty.json";
import wPAM from "./Json/QuestionSetWrappers/PatientActivation.json";
import wProms from "./Json/QuestionSetWrappers/Proms.json";
import wPSEQ8and9 from "./Json/QuestionSetWrappers/PSEQ8And9.json";
import wStartBack from "./Json/QuestionSetWrappers/StartBack.json";
import wPainBaseline from "./Json/QuestionSetWrappers/PainBaseline.json";
import wPainDischarge from "./Json/QuestionSetWrappers/PainDischarge.json";

export async function getJsonQuestionnaire(questionUUID, answersUuid, questionnaireUuid) {
    let initialValues;
    switch (questionUUID) {
        //testingElements
        case "testingElements":
            return [
                createQuestionnaire([qTestingElements, qTestingElementsFailure], wEmpty, ["", ""]),
                await createQuestionnaireInitialValues([iTestingElements, iTestingElementsFailure]),
            ];
        //Proms
        case "120ph":
            return [
                createQuestionnaire([qGeneralPromsInitial, qEQ5D, qStartMsk, qPSEQ8And9], wProms, ["", "", "", ""]),
                await createQuestionnaireInitialValues([iGeneralPromsInitial, iEQ5D, iStartMsk, iPSEQ8And9]),
            ];
        //Proms south
        case "093pa":
            return [
                createQuestionnaire([qGeneralPromsInitial, qEQ5D, qStartMsk], wProms, ["", "", ""]),
                await createQuestionnaireInitialValues([iGeneralPromsInitial, iEQ5D, iStartMsk]),
            ];
        //MskPromsBaseline
        case "12aia":
            return [
                createQuestionnaire([qMSK, qEQ5D, qPSFS, qStartMsk, qMskBaselineHealth, qMskBaselinePersonal], wEmpty, [
                    "The following questions are designed to help your clinician understand more about your symptoms, and how they are impacting on you. This will enable us to ensure your treatment is individualised to you, and your needs. This section should take no more than five minutes. [NEWLINE] [NEWLINE] Please respond to these questions with reference to why you have been referred to the MSK/Physiotherapy service. If you have more than one problem for which we are seeing you e.g. you have both back pain and foot pain, then please consider both problems when answering the questions.",
                    "",
                    "",
                    "",
                    "Thank you for completing those questions. This second set of questions allows you to provide some more detail regarding your symptoms and general health. This will allow your clinician to obtain a clear picture of how they can best help you. This section should take no more than five minutes:",
                    "Thank you for completing those questions. This final set of questions is designed to inform your clinician a little more about you as a person to ensure your treatment is individualised to you, and your needs. This section should take no more than five minutes:",
                ]),
                await createQuestionnaireInitialValues([
                    iMSK,
                    iEQ5D,
                    iPSFS,
                    iStartMsk,
                    iMskBaselineHealth,
                    iMskBaselinePersonal,
                ]),
            ];
        //MskPromsDischarge
        case "poa2h":
            return [
                createQuestionnaire(
                    [qMSK, qEQ5D, qPSFS, qStartMsk, qMskDischargeHealth, qMskDischargePersonal, qMskPrems],
                    wEmpty,
                    [
                        "The following questions are designed to help your clinician understand more about your current symptoms (if any), and how they are impacting on you. This will enable us to understand how effective your treatment has been. This section should take no more than five minutes. [NEWLINE] [NEWLINE] Please respond to these questions with reference to why you have been referred to the MSK/Physiotherapy service. If you have more than one problem for which we are seeing you e.g. you have both back pain and foot pain, then please consider both problems when answering the questions.",
                        "",
                        "",
                        "",
                        "Thank you for completing those questions. This second set of questions allows you to provide some more detail regarding your symptoms and general health. This will allow us to understand not only how effective your treatment has been at resolving your symptoms, but also how well we have impacted your wider health. This section should take no more than five minutes:",
                        "Thank you for completing those questions. This final set of questions will allow us to understand how well we have impacted your wider health and wellbeing. This section should take no more than five minutes:",
                        "",
                    ]
                ),
                await createQuestionnaireInitialValues([
                    iMSK,
                    iEQ5D,
                    iPSFS,
                    iStartMsk,
                    iMskDischargeHealth,
                    iMskDischargePersonal,
                    iMskPrems,
                ]),
            ];
        //MskPromsMonthsAfterDischarge
        case "bhaswe":
            return [
                createQuestionnaire(
                    [qMSK, qEQ5D, qStartMsk, qMskDischargeHealth, qMskDischargePersonal, qMskMonthsDischargePrems],
                    wEmpty,
                    [
                        "The following questions are designed to help your clinician understand more about your current symptoms (if any), and how they are impacting on you. This will enable us to understand how effective your treatment has been. This section should take no more than five minutes. [NEWLINE] [NEWLINE] Please respond to these questions with reference to why you have been referred to the MSK/Physiotherapy service. If you have more than one problem for which we are seeing you e.g. you have both back pain and foot pain, then please consider both problems when answering the questions.",
                        "",
                        "",
                        "Thank you for completing those questions. This second set of questions allows you to provide some more detail regarding your symptoms and general health. This will allow your clinician to obtain a clear picture of how they can best help you. This section should take no more than five minutes:",
                        "Thank you for completing those questions. This final set of questions is designed to inform your clinician a little more about you as a person to ensure your treatment is individualised to you, and your needs. This section should take no more than five minutes:",
                        "",
                    ]
                ),
                await createQuestionnaireInitialValues([
                    iMSK,
                    iEQ5D,
                    iStartMsk,
                    iMskDischargeHealth,
                    iMskDischargePersonal,
                    iMskMonthsDischargePrems,
                ]),
            ];
        //Decon
        case "92opa":
            return [createQuestionnaire([qDecon], wDecon, [""]), await createQuestionnaireInitialValues([iDecon])];
        //EQ5D
        case "apwed":
            return [createQuestionnaire([qEQ5D], wEmpty, [""]), await createQuestionnaireInitialValues([iEQ5D])];
        //GAD7
        case "bijwa":
            return [createQuestionnaire([qGAD7], wEmpty, [""]), await createQuestionnaireInitialValues([iGAD7])];
        //MedialBranchBlock
        case "ph28a":
            return [
                createQuestionnaire([qMedialBranchBlock], wEmpty, [""]),
                await createQuestionnaireInitialValues([iMedialBranchBlock]),
            ];
        //MSK
        case "9032m":
            return [createQuestionnaire([qMSK], wEmpty, [""]), await createQuestionnaireInitialValues([iMSK])];
        //MskBaselineHealth
        case "ejaqr":
            return [
                createQuestionnaire([qMskBaselineHealth], wEmpty, [""]),
                await createQuestionnaireInitialValues([iMskBaselineHealth]),
            ];
        //MskBaselinePersonal
        case "fioja":
            return [
                createQuestionnaire([qMskBaselinePersonal], wEmpty, [""]),
                await createQuestionnaireInitialValues([iMskBaselinePersonal]),
            ];
        //MskDischargeHealth
        case "gikow":
            return [
                createQuestionnaire([qMskDischargeHealth], wEmpty, [""]),
                await createQuestionnaireInitialValues([iMskDischargeHealth]),
            ];
        //MskDischargePersonal
        case "hpoaw":
            return [
                createQuestionnaire([qMskDischargePersonal], wEmpty, [""]),
                await createQuestionnaireInitialValues([iMskDischargePersonal]),
            ];
        //MskMonthsDischargePrems
        case "iu890":
            return [
                createQuestionnaire([qMskMonthsDischargePrems], wEmpty, [""]),
                await createQuestionnaireInitialValues([iMskMonthsDischargePrems]),
            ];
        //Msk Prems
        case "kaimj":
            return [
                createQuestionnaire([qMskPrems], wEmpty, [""]),
                await createQuestionnaireInitialValues([qMskPrems]),
            ];
        //PatientActivation
        case "r03jg":
            return [createQuestionnaire([qPAM], wPAM, [""]), await createQuestionnaireInitialValues([iPAM])];
        //PHQ9
        case "lca91":
            return [createQuestionnaire([qPHQ9], wEmpty, [""]), await createQuestionnaireInitialValues([iPHQ9])];
        //PHQ8
        case "l4289":
            return [createQuestionnaire([qPHQ8], wEmpty, [""]), await createQuestionnaireInitialValues([iPHQ8])];
        //GeneralPromsInitial
        case "mklaw":
            return [
                createQuestionnaire([qGeneralPromsInitial], wProms, [""]),
                await createQuestionnaireInitialValues([iGeneralPromsInitial]),
            ];
        //ManchesterPromsInitial
        case "94lrp":
            return [
                createQuestionnaire([qManchesterPromsInitial], wProms, [""]),
                await createQuestionnaireInitialValues([iManchesterPromsInitial]),
            ];
        //PSEQ8And9
        case "n890a":
            return [
                createQuestionnaire([qPSEQ8And9], wPSEQ8and9, [""]),
                await createQuestionnaireInitialValues([iPSEQ8And9]),
            ];
        //PSFS Baseline
        case "omaw4":
            return [createQuestionnaire([qPSFS], wEmpty, [""]), await createQuestionnaireInitialValues([iPSFS])];
        //PSFS Discharge
        case "om6w4":
            initialValues = await createQuestionnaireInitialValues(
                [qPSFSDischarge],
                "om6w4",
                answersUuid,
                questionnaireUuid
            );
            return [createQuestionnaire([qPSFSDischarge], wEmpty, [""]), initialValues];
        //SleepProgramme
        case "p21af":
            return [
                createQuestionnaire([qSleepProgramme], wEmpty, [""]),
                await createQuestionnaireInitialValues([iSleepProgramme]),
            ];
        //StartMsk
        case "q456a":
            return [
                createQuestionnaire([qStartMsk], wEmpty, [""]),
                await createQuestionnaireInitialValues([iStartMsk]),
            ];
        //StartBack
        case "q5aaa":
            return [
                createQuestionnaire([qStartBack], wStartBack, [""]),
                await createQuestionnaireInitialValues([iStartBack]),
            ];

        //Pain personal
        case "pzk24":
            return [
                createQuestionnaire([qPainPersonal], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainPersonal]),
            ];
        //Pain personal manchester
        case "kzk2om":
            return [
                createQuestionnaire([qPainPersonalManchester], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainPersonalManchester]),
            ];
        //Bpi
        case "pzz23":
            return [createQuestionnaire([qBpi], wEmpty, [""]), await createQuestionnaireInitialValues([iBpi])];
        //MPFI baseline
        case "okqnv":
            return [createQuestionnaire([qMpfi], wEmpty, [""]), await createQuestionnaireInitialValues([iMpfi])];
        //Pain baseline Health
        case "8zkl5":
            return [
                createQuestionnaire([qPainBaselineHealth], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainBaselineHealth]),
            ];
        //Core10 (Sussex baseline)
        case "lryb0":
            return [createQuestionnaire([qCore10], wEmpty, [""]), await createQuestionnaireInitialValues([iCore10])];
        //Pain Discharge personal
        case "o4129":
            return [
                createQuestionnaire([qPainDischargePersonal], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainDischargePersonal]),
            ];
        //Pain Discharge Health
        case "gnbc1":
            return [
                createQuestionnaire([qPainDischargeHealth], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainDischargeHealth]),
            ];
        //FFT
        case "qwert":
            return [createQuestionnaire([qFft], wEmpty, [""]), await createQuestionnaireInitialValues([iFft])];
        //Pain Medication
        case "med0p":
            return [
                createQuestionnaire([qPainMedication], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainMedication]),
            ];
        //Pain Satisfaction
        case "uyi12":
            return [
                createQuestionnaire([qPainSatisfaction], wEmpty, [""]),
                await createQuestionnaireInitialValues([iPainSatisfaction]),
            ];

        default:
            break;
    }
}
